import styled from 'styled-components/macro';
import { Alert } from '@yme/atoms/alert';
import { AlertMessageWrapper } from '@yme/atoms/alert/styled';
import { colorAccentInfo900Base } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel4 } from '@yme/tokens/typography';
export const DropdownMobileWrapperStyled = styled.div `
  width: auto;

  ${ADAPTIVE.maxWidth.mobile} {
    flex-basis: 100%;
    margin-top: 24px;
  }

  ${ADAPTIVE.minWidth.tablet} {
    width: 231px;
  }
`;
export const TestRideGridWrapperStyled = styled.div `
  flex-basis: 100%;
  max-width: 1440px;
`;
export const ShowAllDealersButton = styled(RegularTextLevel4) `
  cursor: pointer;
  white-space: nowrap;
  text-decoration: underline;
  color: ${colorAccentInfo900Base};
`;
export const AlertStyled = styled(Alert) `
  ${AlertMessageWrapper} {
    flex: ${({ isInfiniteDesktopView }) => (isInfiniteDesktopView ? 'auto' : '1 1 100%')};
  }
`;
export const AlertWrapper = styled.div `
  padding: 0 16px;

  ${ADAPTIVE.minWidth.tablet} {
    padding: 0 24px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 0 48px;
  }
`;
